import { FormControl, FormLabel, Switch } from '@chakra-ui/react';
import { useFormContext, useWatch } from 'react-hook-form';

export function EnabledForm({
  enabledPath,
  otherFieldPath,
  formatValue = (value) => String(value),
}: {
  enabledPath: string;
  otherFieldPath: string;
  formatValue?: (value: unknown) => string;
}) {
  const form = useFormContext();
  const isEnabled = useWatch({
    name: enabledPath,
    control: form.control,
  });

  const otherFieldValue = useWatch({
    name: otherFieldPath,
    control: form.control,
  });

  return (
    <FormControl display="flex" alignItems="center" gap={2}>
      <Switch id={enabledPath} {...form.register(enabledPath)} />

      <FormLabel htmlFor={enabledPath} mb={0}>
        {isEnabled ? 'Enabled' : `Disabled (${formatValue(otherFieldValue)})`}
      </FormLabel>
    </FormControl>
  );
}
